import { observable, reaction, action } from 'mobx'
import { message } from 'antd'
import {
  getCanByIdFetchHandler,
  getUserNameByIdFetchHandler,
  addCanNameFetchHandler,
  getChoseCanDataFetchHandler,
  getSingleDeviceHistoricalData,
} from '../utils/fetchData'
import OverViewViewStore from './OverViewViewStore'
import GlobalControlStore from './GlobalControlStore'
import UserInfoStore from './UserInfoStore'

class ChosenCanStatusStore {
  @observable canId = null
  @observable previousId = null
  @observable canInfo = null
  @observable statistics = []
  @observable supervisorName = null
  @observable supervisorPhone = null
  @observable canName = ''
  @observable finalCanNameValue = null
  @observable canHeight = 0
  @observable isShowDataDetail = true
  @observable historyClearanceArr = []
  @observable dataType = 'DAY'
  @observable totalKilos = 0
  // 1拖N
  @observable dragArr = []

  @action
  setCanId(canId) {
    this.previousId = this.canId
    this.canId = canId
    if (!canId) {
      OverViewViewStore.isCanDetailVisible = false
    } else {
      OverViewViewStore.isCanDetailVisible = true
      // 重置数据类型为默认的DAY，确保每次选择新设备时都从日数据开始
      this.dataType = 'DAY'
    }
  }

  @action
  updateHistoricalList() {
    if (this.canId) {
      getSingleDeviceHistoricalData(
        this.canId,
        this.dataType,
        (data) => {
          this.historyClearanceArr = data.content
          let totalKilos = 0
          for (let can of data.content) {
            totalKilos += can.kilograms
          }
          this.totalKilos = totalKilos
        },
        (err) => {}
      )
    }
  }
}
const store = new ChosenCanStatusStore()
reaction(
  () => store.canId,
  (id, reaction) => {
    if (id) {
      getSingleDeviceHistoricalData(
        id,
        store.dataType,
        (data) => {
          store.historyClearanceArr = data.content
          let totalKilos = 0
          for (let can of data.content) {
            totalKilos += can.kilograms
          }
          store.totalKilos = totalKilos
        },
        (err) => {}
      )
    }
  }
)
reaction(
  //updateCanInfo
  () => store.canId,
  (canId, reaction) => {
    if (canId) {
      GlobalControlStore.showLoading = true
      getCanByIdFetchHandler(
        canId,
        (res1) => {
          GlobalControlStore.showLoading = false
          let res = res1.content
          // 1拖N判断
          if (res1.content.subSensors) {
            store.dragArr = res1.content.subSensors
            res1.content.subSensors.forEach((sub, index) => {
              if (sub.id === canId) {
                res = res1.content.subSensors[index]
              }
            })
          } else {
            store.dragArr = []
          }
          store.canInfo = res
          store.canName = res.serial_number ? res.serial_number : res.id
          store.canHeight = res.height - res.remainingHeight
          store.supervisorName = res.supervisorName
          if (res.supervisorId) {
            //已经分配的桶
            // 分级账号屏蔽该请求
            if (UserInfoStore.accountIsNotGraded) {
              getUserNameByIdFetchHandler(
                res.supervisorId,
                (data) => {
                  store.supervisorName = data.name
                  store.supervisorPhone = data.phone || ''
                },
                (err) => {},
                () => {}
              )
            } else {
              //分级账户直接从 /sensors 接口获取
              store.supervisorName = res.cleanerName
              store.supervisorPhone = res.cleanerPhone
            }
          } else {
            //未分配的桶没有supervisorId
            store.supervisorName = '--'
            store.supervisorPhone = '--'
          }
        },
        (err) => {
          message.error('获取桶信息失败')
        },
        () => {
          GlobalControlStore.showLoading = false
        }
      )
    }
  }
)
reaction(
  //updateStatistics
  () => store.canId,
  (canId, reaction) => {
    if (canId) {
      // 先重置图表更新标志，确保能触发更新
      OverViewViewStore.chartNeedUpdate = false
      getChoseCanDataFetchHandler(
        canId,
        'MONTH',
        (data) => {
          if (data.length === 0) {
            OverViewViewStore.flag = true
          } else {
            OverViewViewStore.flag = false
          }
          if (data) {
            data.sort((a, b) => {
              if (a.time < b.time) return -1
              else return 1
            })
            store.statistics = data
            // 数据加载完成后，设置更新标志为true
            OverViewViewStore.chartNeedUpdate = true
          }
        },
        (err) => {}
      )
    }
  }
)

reaction(
  //setCanNameReaction
  () => store.finalCanNameValue,
  (canName, reaction) => {
    addCanNameFetchHandler(
      store.canId,
      canName,
      (data) => {},
      () => {},
      () => {}
    )
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/ChosenCanStatusStore.js